module.exports = __webpack_public_path__ + "static/media/video_consent_start_record_urdu.285bf5e3.mp3";